export const common = {
  "home.awards.title": "수상 실적",
  "home.awards.pause": "수상 내역 자동 재생 일시 정지",
  "home.awards.play": "수상 내역 자동 재생",
  "home.awards.financialAlgorithm": "금융 알고리즘 선도 기업",
  "home.awards.asiaPacificGold": "아시아 태평양 금 거래 선도 브랜드",
  "home.awards.preciousMetals": "신뢰받는 귀금속 거래 브랜드",
  "home.awards.digitalFinance": "디지털 금융 혁신 기여 기업",
  "home.awards.quantitativeTrading": "퀀트 거래 기술 우수 기업",
  // 내비게이션
'nav.home': '홈',
'nav.trading': '거래',
'nav.markets': '시장',
'nav.news': '뉴스',
'nav.about': '회사 소개',
'nav.contact': '문의하기',
'nav.login': '로그인',
'nav.register': '회원가입',

// 히어로 섹션
'hero.title': '프리미엄 금·은 거래 플랫폼',
'hero.subtitle': '홍콩 라이선스를 보유한 회사로서, 유럽 투자자에게 안전하고 전문적인 귀금속 거래 서비스를 제공합니다.',
'hero.cta.start': '거래 시작하기',
'hero.cta.learn': '자세히 보기',

// 홈
'home.licenseHK': '홍콩 라이선스',
'home.bankSec': '은행급 보안',
'home.247s': '24/7 고객지원',
'home.global': '글로벌 비전',
'home.tradingPlat': '거래 플랫폼',
'home.tradingWith': '강력하고 안정적인',
'home.exp': '귀금속 전용으로 설계된 세계적 수준의 거래 플랫폼을 경험해 보세요. MT5는 기관급 도구, 초고속 체결, 그리고 종합적인 시장 분석 기능을 제공합니다.',
'home.dlMT5': 'MT5 다운로드',
'home.watchDemo': '데모 보기',
'home.tradingIns': '거래 상품',
'home.exeSpeed': '체결 속도',
'home.mktAccess': '시장 접근',
'home.uptime': '가동률',
'home.allDevices': '모든 기기 지원',
'home.mktInt': '시장 정보',
'home.mktInt.desc': '귀금속 거래에 영향을 미치는 경제 이벤트와 시장 뉴스를 실시간으로 파악',
'home.lastUpdate': '최종 업데이트',
'home.ecoCal': '경제 달력',
'home.refresh': '새로 고침',
'home.currency': '통화',
'home.events': '이벤트',
'home.previous': '이전값',
'home.forecast': '예상',
'home.actual': '실제',
'home.mktNews': '시장 뉴스',
'home.seeMore': '더 보기',
'home.ecoData': '경제 데이터는 여러 금융 데이터 제공업체에서 제공하며 • 시장 뉴스는 주요 금융 미디어에서 제공합니다.',
'home.ac': '고급 차트 기능',
'home.pta': '80개 이상의 기술 지표와 분석 도구를 갖춘 전문적인 기술 분석',
'home.mpa': '멀티 플랫폼 접근',
'home.tsa': '데스크톱, 웹, 모바일 애플리케이션에서 끊김 없이 거래 가능',
'home.st': '안전한 거래',
'home.bls': '은행급 암호화 기술로 데이터 전송 및 저장을 보호',
'home.247': '24시간 시장 접근',
'home.rtc': '언제 어디서나 전 세계 귀금속 시장에 연결하여 거래 가능',
'home.at': '자동 거래',
'home.ea': 'EA(Expert Advisor)를 통한 알고리즘 및 자동화 거래 지원',
'home.lfe': '초고속 체결',
'home.ull': '초저지연 주문 체결로 경쟁력 있는 스프레드와 즉시 체결 제공',

// 특징
'features.title': '당사 플랫폼을 선택해야 하는 이유',
'features.security.title': '은행급 보안',
'features.security.desc': '첨단 암호화 및 다층 보안 체계로 고객의 자산을 철저히 보호합니다.',
'features.licensed.title': '정식 라이선스 보유',
'features.licensed.desc': '홍콩 금융 당국의 규제를 받아 투명하고 합법적으로 운영됩니다.',
'features.realtime.title': '실시간 거래',
'features.realtime.desc': '실시간 시장 데이터와 즉각적인 주문 체결로 최적의 거래 기회를 포착합니다.',
'features.support.title': '24/7 고객 서비스',
'features.support.desc': '전문 다국어 지원팀이 연중무휴로 서비스를 제공합니다.',
'features.lmd': '실시간 시장 데이터',
'features.rtp': '귀금속 실시간 시세',

// 시장
'markets.title': '실시간 시장 가격',
'markets.gold': '금',
'markets.silver': '은',
'markets.platinum': '플래티넘',
'markets.palladium': '팔라듐',
'markets.price': '가격',
'markets.change': '변동',
'markets.high': '24시간 최고가',
'markets.low': '24시간 최저가',
'markets.contractDetials': '계약 세부정보',
'markets.contractDetials.desc': '귀금속 거래의 포괄적인 계약 사양 및 거래 조건',
'markets.tradingExample': '거래 예시',
'markets.goldExample': '금 거래 예시',
'markets.silverExample': '은 거래 예시',
'markets.instrument': '상품',
'markets.lotSize': '거래 단위 (Lot)',
'markets.entPrice': '진입 가격',
'markets.marReq': '필요 증거금',
'markets.pip': '핍 가치',
'markets.pmt': '귀금속 거래',
'markets.ctt': '귀금속 거래의 조건, 사양 및 위험 관리 사항을 종합적으로 이해하고, 금과 은 투자에 필요한 정보를 제공합니다.',
'markets.vts': '거래 사양 보기',
'markets.dcd': '계약 세부정보 다운로드',
'markets.ec': '체결 속도',
'markets.th': '거래 시간',
'markets.ms': '최소 스프레드 (pips)',
'markets.ml': '최대 레버리지',
'markets.mr': '증거금 요건',
'markets.lo': '계좌 유형별 레버리지 옵션 및 증거금 요건',
'markets.leverage': '레버리지',
'markets.margin': '증거금',
'markets.mind': '최소 입금액',
'markets.mc': '증거금 계산기',
'markets.gmc': '금 증거금 계산',
'markets.cp': '현재 가격',
'markets.cv': '계약 가치',
'markets.smc': '은 증거금 계산',
'markets.rm': '리스크 관리',
'markets.crm': '포괄적인 도구와 전략으로 고객의 투자를 보호',
'markets.rtg': '위험 감내도 가이드',
'markets.rd': '리스크 공시',
'markets.tpm': '귀금속 거래에는 큰 손실 위험이 있으며 모든 투자자에게 적합하지 않을 수 있습니다. 과거의 성과는 미래의 결과를 보장하지 않습니다.',
'markets.lcw': '레버리지는 수익을 확대할 수 있지만 손실 또한 확대될 수 있습니다. 거래 결정을 내리기 전에 투자 목표, 경험 수준 및 위험 감내도를 신중히 고려하십시오.',
'markets.ysb': '귀금속 거래와 관련된 모든 위험을 충분히 이해하고, 의문이 있을 경우 독립적인 재무 고문에게 상담하십시오.',
'markets.rfr': '전체 리스크 공시 읽기',
'markets.cra': '리스크 상담사에게 문의',
'markets.tho': '거래 시간',
'markets.moh': '귀금속 시장의 운영 시간 및 휴일 일정',
'markets.wts': '주간 거래 일정',
'markets.note': '주의사항',
'markets.atad': '모든 시간은 GMT+8 기준으로 표시됩니다. 주요 휴일 또는 높은 변동성 기간에는 거래가 일시 중단될 수 있습니다.',
'markets.hs': '휴일 일정',
'markets.mclo': '시장 휴장',
'markets.eclo': '조기 마감',
'markets.hn': '휴일 공지',
'markets.thm': '공휴일 기간 동안 거래 시간이 조정될 수 있습니다. 공지를 참고해 주십시오.',
'markets.cms': '현재 시장 상태',
'markets.mac': '현재 시장은 개장 중입니다.',
'markets.st': '서버 시간 (GMT+8)',
'markets.ts': '거래 사양',
'markets.dtc': '금 및 은 상품의 상세 거래 조건과 사양',
'markets.msp': '최소 스프레드',
'markets.minls': '최소 거래 단위',
'markets.maxls': '최대 거래 단위',
'markets.commission': '수수료',
'markets.sls': '스왑 이자 (롱/숏)',
'markets.in': '중요 안내',
'markets.smv': '높은 변동성 또는 주요 뉴스 발표 시 스프레드가 확대될 수 있습니다.',
'markets.sra': '스왑 금리는 매일 갱신되며, 시장 상황에 따라 변경될 수 있습니다.',
'markets.mlm': '중요 뉴스 발표 시 최대 레버리지가 일시적으로 축소될 수 있습니다.',
'markets.ata': '모든 시간은 GMT+0 기준으로 표시됩니다.',

// 뉴스
'news.title': '최신 시장 뉴스 및 분석',
'news.subtitle': '전문가의 통찰과 시장 동향을 실시간으로 확인',
'news.readMore': '더 읽기',
'news.category.analysis': '시장 분석',
'news.category.news': '속보 뉴스',
'news.category.insights': '전문가 의견',
'news.category.education': '교육',
'news.date': '게시일',
'news.author': '작성자',

 // 고객 추천
'home.partners.title': '파트너',
'home.partners.subtitle': '글로벌 유동성, 금융 기술 및 거래 인프라 분야의 선도 기업들과 협력합니다.',
'testimonials.title': '전 세계 투자자들의 신뢰를 받고 있습니다',
'testimonials.client1.name': 'Marcus Weber',
'testimonials.client1.location': '독일 • 프랑크푸르트',
'testimonials.client1.text': '호가가 투명하고 체결이 안정적입니다. 강력한 보안 기능 덕분에 더욱 신뢰할 수 있습니다.',
'testimonials.client2.name': 'Sophie Dubois',
'testimonials.client2.location': '프랑스 • 파리',
'testimonials.client2.text': '전문적인 서비스와 경쟁력 있는 스프레드, 그리고 다국어 지원팀의 신속한 대응이 큰 도움이 됩니다.',
'testimonials.client3.name': 'Alessandro Rossi',
'testimonials.client3.location': '이탈리아 • 밀라노',
'testimonials.client3.text': '체결이 매우 빠르고 분석 도구가 우수합니다. 귀금속 거래를 진지하게 고려하는 분께 추천합니다.',

// 푸터
'footer.company': '회사',
'footer.trading': '거래',
'footer.support': '지원',
'footer.legal': '법률',
'footer.about': '회사 소개',
'footer.careers': '채용',
'footer.news': '뉴스',
'footer.platforms': '거래 플랫폼',
'footer.education': '교육',
'footer.analysis': '시장 분석',
'footer.help': '도움말 센터',
'footer.contact': '문의하기',
'footer.faq': '자주 묻는 질문',
'footer.terms': '이용약관',
'footer.privacy': '개인정보 처리방침',
'footer.risk': '리스크 공시',
'footer.copyright': '© 2024 GOLD Label Global Limited. 모든 권리 보유.',
'footer.license': "홍콩에 설립된 회사",
'footer.riskwarning': '위험 고지',
'footer.disclaimer': '증거금 거래는 레버리지형 금융상품으로, 예치금을 초과한 손실이 발생할 수 있습니다. 고객님은 관련 기초자산을 실제로 보유하지 않습니다. 거래 전 당사의 「리스크 공시문」을 반드시 숙지하시기 바랍니다. 관련 위험을 충분히 이해하고, 리스크 익스포저를 신중히 관리해 주십시오. 본 웹사이트 또는 그 정보에 근거한 행위 또는 불행위로 발생한 결과에 대하여 당사는 일체의 책임을 지지 않습니다.',
'footer.jurisdiction': "서비스 제공 관할지역 안내",
'footer.jurisdictionDisclaimer': "본 웹사이트에 설명된 서비스는 홍콩 및 미국 이외의 관할지역에 있는 적격 고객에게만 제공되며, 고객 소재지의 관련 법령상 해당 서비스 제공이 허용되는 경우에 한합니다. 홍콩 또는 미국 거주자, 또는 해당 서비스의 제공이 불법이거나 금지된 관할지역의 사람에게는 서비스를 제공하지 않습니다. 본 웹사이트는 제한 관할지역의 사람을 대상으로 하지 않으며, 그러한 사람에 대한 제안, 권유 또는 추천을 구성하지 않습니다.",
'footer.relatedEntity': '기타 관련 법인',
'footer.saintLuciaEntity': 'Gold Label Global (SL) Limited는 2026년 9월 4일 세인트루시아에 설립된 국제사업회사이며, 회사 등록번호는 2026-00680입니다. 등록 사무소: Ground Floor, The Sotheby Building, Rodney Village, Rodney Bay, Gros-Islet, Saint Lucia. 등록 사무소는 법률 및 규제 준수 목적으로만 유지되며, 회사의 실제 영업 장소가 아니고 운영, 고객 방문 또는 서신 수발에 사용되지 않습니다.',
'footer.regNo': '회사 등록번호',

// 공통
'common.language': '언어',
'common.loading': '로딩 중…',
'common.error': '오류',
'common.success': '성공',
'common.close': '닫기',
'common.save': '저장',
'common.cancel': '취소',
'common.continue': '계속',
'common.back': '뒤로',
'common.next': '다음',
'common.previous': '이전',
'common.submit': '제출',
'common.reset': '초기화',

// 회사 소개
'about.yearsOfExp': '다년간의 경험',
'about.yearsOfExp.desc': '귀금속 거래 분야에서 수십 년간 축적된 전문성',
'about.dailyTrade': '일일 거래량',
'about.dailyTrade.desc': '홍콩의 일일 금·은 거래 규모는 약 800억 홍콩달러에 달합니다',
'about.satClients': '고객 만족도',
'about.satClients.desc': '전 세계의 다양한 개인 및 기관 고객에게 서비스를 제공합니다',
'about.exeSpeed': '체결 속도',
'about.exeSpeed.desc': '초고속 주문 집행 기술',
'about.ourAch': '당사의 성과',
'about.ourAch.desc': '업계 선도적 성과로 다수의 인정을 받았습니다',
'about.companyProfile': '회사 소개',
'about.about1': 'Gold Label Global 소개',
'about.about2': 'Gold Label Global Limited는 홍콩 정부가 인가한 유한회사이자 중국 황금백은거래소 회원사입니다. 홍콩에서는 매일 약 800억 홍콩달러 규모의 금·은 거래가 이루어지며, 당사는 세계적 수준의 경험을 보유하고 있습니다.',
'about.about3': 'Gold Label Global의 경영진은 금·은 거래 분야에서 20년 이상 전문적으로 활동해 왔으며, 수많은 고객과 기관을 지원했습니다. 누적 고객 거래 규모는 수백억에 달하며, 고객과 업계 전문가들로부터 높은 평가를 받고 있습니다.',
'about.about4': '저희는 신속하고 안정적인 고품질 거래 환경을 제공하기 위해 노력합니다. 국제적 수준의 거래 시스템을 도입하고, 최고 수준의 기술팀이 보다 강력하고 포괄적인 거래 솔루션을 개발하여 속도와 안정성, 완성도를 높이고 있습니다.',
'about.about5': 'Gold Label Global은 고객과 함께 수익을 창출하고 성장을 나누겠습니다.',
'about.about6': '귀금속 거래 여정에서의 성장과, 글로벌 금융시장에서의 탁월함에 대한 당사의 약속을 확인해 보십시오.',
'about.about7': '홍콩 정부 인가 유한회사이자 중국 황금백은거래소 회원사로서, 당사는 매일 약 800억 홍콩달러 규모의 금·은 거래를 처리하고 있으며 풍부한 거래 경험을 보유하고 있습니다.',
'about.proTeam': '전문 팀',
'about.proTeam.desc': '경영진은 금·은 거래 분야에서 20년 이상의 경험을 보유하고 있으며, 다수의 고객과 기관을 지원합니다.',
'about.proService': '전문 서비스',
'about.proService.desc': '전문 고객지원팀이 24시간 온라인/모바일로 대응하며, 고객 이슈에 맞춘 솔루션을 제공합니다.',
'about.sec': '안전 최우선',
'about.sec.desc': '거래상대방 위험을 제거하고 주문을 시장에 직접 전달하여, 투명하고 더욱 안전한 거래를 구현합니다.',
'about.strict': '엄격한 규제',
'about.strict.desc': 'Gold Label Global은 홍콩의 상업 거래소로서 홍콩 정부의 감독을 받으며, 홍콩 상업거래협회 회원사입니다.',
'about.fastDes': '신속한 입금',
'about.fastDes.desc': '24시간 업무 지원으로 초단위 입금, 즉시 이용이 가능합니다.',
'about.productSafe': '상품 안정성',
'about.productSafe.desc': '전 세계 주요 귀금속 상품을 포괄하며 안전하고 신뢰할 수 있습니다.',
'about.whyGLB': '왜 Gold Label Global인가',
'about.whyGLB.desc': '귀금속 거래 분야에서 당사가 최선의 선택이 되는 핵심 강점을 확인하세요',
'about.readyToStart': '지금 거래를 시작할 준비가 되셨습니까?',
'about.join': '수많은 고객이 GOLD Label Global을 신뢰하고 귀금속 거래 니즈를 충족하고 있습니다.',
'about.openTradingAcc': '거래 계좌 개설',
'about.contactTeam': '당사 팀에 문의',
'about.co': '상생 협력',
'about.co.desc': '고객 및 이해관계자와 상호 이익의 장기 파트너십 구축',
'about.safety': '안전 보장',
'about.safety.desc': '모든 거래 활동이 최고 수준의 보안 기준을 충족하도록 보장합니다',
'about.integrity': '정직과 투명성',
'about.integrity.desc': '최고 수준의 정직성과 투명성을 준수합니다',
'about.professional': '전문성',
'about.professional.desc': '탁월한 전문성으로 우수한 서비스를 제공합니다',
'about.fast': '신속성',
'about.fast.desc': '신속한 체결과 즉각적인 고객 대응을 제공합니다',
'about.coreValue': '핵심 가치',
'about.coreValue.desc': '귀금속 거래 분야에서 탁월함을 추구하기 위한 당사의 핵심 원칙',

 // 문의하기
'contact.sendUsMsg': '메시지 보내기',
'contact.fillOut': '아래 양식을 작성해 주시면, 저희 팀이 24시간 이내에 회신드립니다.',
'contact.inqType': '문의 유형',
'contact.genInq': '일반 문의',
'contact.accSup': '계정 지원',
'contact.traSup': '거래 지원',
'contact.techSup': '기술 지원',
'contact.partner': '파트너십 문의',
'contact.fullname': '성명 *',
'contact.email': '이메일 주소 *',
'contact.phone': '전화번호',
'contact.subject': '제목 *',
'contact.msg': '메시지 *',
'contact.sendMsg': '메시지 보내기',
'contact.whyUs': '왜 우리를 선택해야 하나요?',
'contact.regSec': '규제 및 보안',
'contact.licAndReg': '규제된 안전한 거래 환경과 첨단 보안 시스템으로 고객의 투자를 보호합니다.',
'contact.expSup': '전문가 지원',
'contact.proService': '전문 트레이딩 전문가가 24시간 언제든 귀하의 거래 관련 문의를 지원합니다.',
'contact.fastExe': '빠른 주문 체결',
'contact.lightFast': '초고속 주문 처리와 최소한의 슬리피지로 최상의 거래 성과를 제공합니다.',
'contact.glbNet': '글로벌 시장',
'contact.asscessToint': '국제 귀금속 시장에 직접 연결되어 경쟁력 있는 스프레드와 높은 유동성을 제공합니다.',
'contact.followUs': '소셜 미디어에서 팔로우하세요:',
'contact.contactOutPro': '거래 지원, 계정 문제 또는 일반 문의가 있으신 경우, 저희 전문팀에 문의해 주십시오:',
'contact.officeAddress': '사무실 주소',
'contact.bussHour': '업무시간: 월요일–금요일 9:00–18:00 (GMT+8)',
'contact.phoneSupp': '전화 지원',
'contact.mainOffice': '본사',
'contact.availableServices': '제공 서비스:',
'contact.accOpenSup': '계좌 개설 지원',
'contact.tradSup': '거래 플랫폼 지원',
'contact.genSup': '일반 지원',
'contact.emailSup': '이메일 지원',
'contact.responseTime': '응답 시간:',
'contact.genInq24': '일반 문의: 24시간 이내',
'contact.techSup24': '기술 지원: 4시간 이내',
'contact.accIss24': '계정 문제: 2시간 이내',
'contact.needImSup': '즉시 지원이 필요하신가요?',
'contact.needImSup.desc': '저희 트레이딩 전문가가 24시간 365일 긴급 거래 및 계정 관련 지원을 제공합니다.',
'contact.callNow': '지금 전화하기',
'contact.sendEmail': '이메일 보내기',
'contact.contactUs': '문의하기',
'contact.getInTouch': '전문 트레이딩 팀과 연락하세요. 귀금속 거래 성공을 위해 최선을 다해 지원합니다.',
'contact.247Sup': '24시간 고객지원',
'contact.247Sup.desc': '모든 거래 관련 요청을 연중무휴로 지원합니다.',
'contact.dirLine': '전용 직통전화',
'contact.dirLine.desc': '트레이딩 전문가와 직접 통화 가능',
'contact.hkOffice': '홍콩 오피스',
'contact.hkOffice.desc': '홍콩 금융 중심지에 위치',

// 플랫폼
'platform.wco': '왜 우리 MT5 플랫폼을 선택해야 하나요?',
'platform.etd': '전문 트레이더를 위해 설계된 고급 거래 플랫폼의 탁월한 성능을 직접 경험해 보세요.',
'platform.rts': '거래를 시작할 준비가 되셨습니까?',
'platform.jto': '수천 명의 트레이더들이 귀금속 거래를 위해 저희 플랫폼을 신뢰하고 있습니다.',
'platform.ola': '실거래 계좌 개설',
'platform.tda': '모의 계좌 체험',
'platform.dmt': 'MT5 플랫폼 다운로드',
'platform.ayt': 'MT5 애플리케이션을 통해 모든 기기에서 계정을 로그인하고 관리할 수 있습니다.',
'platform.free': '무료',
'platform.dn': '지금 다운로드',
'platform.sr': '시스템 요구사항',
'platform.nh': '초보자 지원이 필요하신가요?',
'platform.os': '저희 지원팀이 설정 및 거래 시작을 단계별로 도와드립니다.',
'platform.ug': '사용 가이드',
'platform.cs': '지원 문의',
'platform.si': '안정적인 인터넷 연결 필요',
'platform.ptf': '강력한 거래 기능',
'platform.epg': '초보자와 전문가 모두를 위한 전문급 도구',
'platform.ac': '고급 차트',
'platform.pct': '80개 이상의 기술 지표와 다양한 시간 프레임을 제공하여 시장을 심층 분석할 수 있습니다.',
'platform.lfe': '초고속 체결',
'platform.ull': '초저지연 주문으로 0.01초 내 체결, 정확한 진입과 청산 지원.',
'platform.ea': '자동매매 (EA)',
'platform.atc': '사용자 지정 EA와 알고리즘 전략을 지원하는 자동 거래 기능 제공.',
'platform.rm': '리스크 관리',
'platform.crm': '손절, 익절 및 포지션 관리 등 종합적인 리스크 관리 도구 제공.',
'platform.mpa': '멀티 플랫폼 접근',
'platform.tsa': '데스크톱, 웹, 모바일에서 원활하게 거래 가능하며 계정이 동기화됩니다.',
'platform.gm': '글로벌 시장',
'platform.ati': '귀금속, 외환, 지수 및 원자재 등 국제 시장에 접근 가능합니다.',
'platform.etw': '세계 최고 수준의 거래 플랫폼을 경험하십시오. 기관급 기술과 초고속 체결로 귀금속, 외환 및 CFD 거래를 제공합니다.',
'platform.download': '다운로드 ',
'platform.wd': '데모 보기',
'platform.es': '체결 속도',
'platform.th': '거래 시간',
'platform.in': '거래 상품',
'platform.lt': '실거래',
'platform.ptt': '전문 거래 도구',
'platform.aig': '전문 트레이더와 엄격한 투자자를 위한 기관급 툴',
'platform.rtd': '실시간 데이터',
'platform.lmd': '실시간 시장 데이터 및 가격 업데이트',
'platform.pa': '가격 알림',
'platform.caf': '가격 변동 및 시장 이벤트 알림을 맞춤 설정 가능',
'platform.this': '거래 내역',
'platform.cth': '완전한 거래 내역 및 성과 분석 제공',
'platform.ec': '경제 캘린더',
'platform.suw': '중요 경제 이벤트 실시간 확인',
'platform.mw': '시장 시세',
'platform.rtp': '모든 거래 가능한 상품의 실시간 시세 및 시장 심도 제공',
'platform.om': '주문 관리',
'platform.aot': '시장가, 지정가, 손절, 트레일링 스탑 등 고급 주문 유형 지원',
'platform.ta': '기술적 분석',
'platform.cta': '사용자 정의 지표 및 도구를 포함한 완전한 기술 분석 세트',
'platform.ufe': '초고속 실행',
'platform.rtc': '트레이딩 및 기술 전문가 팀이 24시간 고객 지원을 제공합니다.',
'platform.247a': '연중무휴 24시간 서비스',
'platform.csp': '경쟁력 있는 스프레드',
'platform.iia': '업계 최고 수준의 스프레드와 투명한 가격 책정, 숨겨진 수수료 없음',
'platform.01pip': '0.1핍부터 시작',
'platform.ffd': 'Windows 10/11용 전체 기능 데스크톱 애플리케이션',
'platform.nma': '모든 기능을 갖춘 네이티브 macOS 애플리케이션',
'platform.mta': 'Android 기기용 모바일 거래 애플리케이션',
'platform.iai': 'iPhone 및 iPad용 거래 애플리케이션',

'faq.tagline': '[translate:무엇을 도와드릴까요?]',
'faq.title': '[translate:무엇을 도와드릴까요?]',
'faq.subtitle': '[translate:자주 묻는 질문(FAQ) 섹션을 통해 빠른 답변을 찾아보세요.]',
'faq.categories': '[translate:카테고리]',
'faq.cantFind': '[translate:찾으시는 정보를 못 찾으셨나요?]',
'faq.supportText': '[translate:FAQ에 없는 내용은 지원팀이 도와드립니다.]',
'faq.contactSupport': '[translate:지원팀에 문의하기]',

'faq.general': '[translate:일반]',
'faq.account': '[translate:계정]',
'faq.trading': '[translate:거래]',
'faq.platform': '[translate:플랫폼]',
'faq.deposits': '[translate:입출금]',
'faq.security': '[translate:보안]',

'faq.general.q1': '[translate:GOLD LABEL GLOBAL LIMITED는 어떤 회사인가요?]',
'faq.general.a1': '[translate:GOLD LABEL GLOBAL LIMITED는 홍콩에 본사를 둔 규제된 귀금속 거래 회사로, MT5 플랫폼을 통해 금, 은 및 기타 귀금속 거래 서비스를 제공합니다.]',
'faq.general.q2': '[translate:어떤 거래 상품을 제공하나요?]',
'faq.general.a2': '[translate:스팟 골드(XAU/USD), 스팟 실버(XAG/USD), 플래티넘, 팔라듐 및 다양한 귀금속 선물 계약을 포함한 폭넓은 상품을 제공합니다.]',
'faq.general.q3': '[translate:거래 시간은 언제인가요?]',
'faq.general.a3': '[translate:귀금속 시장은 일요일 오후 5시(EST)부터 금요일 오후 4시(EST)까지, 주 5일 24시간 운영됩니다.]',
'faq.general.q4': '[translate:투자는 안전한가요?]',
'faq.general.a4': '[translate:네, 당사는 규제와 라이선스를 모두 갖추고 있습니다. 고객 자금은 별도 예치 계좌에 보관되며, 추가적인 보험도 가입되어 있습니다.]',

'faq.account.q1': '[translate:거래 계좌를 개설하려면 어떻게 하나요?]',
'faq.account.a1': '[translate:온라인 신청서 작성, 신분증 제출, 초기 입금을 완료하면 계좌를 개설할 수 있습니다. 일반적으로 1~2영업일이 소요됩니다.]',
'faq.account.q2': '[translate:최소 입금액은 얼마인가요?]',
'faq.account.a2': '[translate:표준 계좌의 최소 입금액은 미화 1,000달러입니다. 더 큰 혜택이 있는 프리미엄 계좌도 제공합니다.]',
'faq.account.q3': '[translate:여러 개의 계좌를 만들 수 있나요?]',
'faq.account.a3': '[translate:예, 다양한 거래 전략이나 통화에 맞춰 여러 개의 계좌를 개설할 수 있습니다.]',
'faq.account.q4': '[translate:계좌 인증은 어떻게 하나요?]',
'faq.account.a4': '[translate:정부 발급 신분증(여권 또는 운전면허증)과 3개월 이내 발행된 주소 증명서(공과금 명세서 또는 은행 명세서)가 필요합니다.]',

'faq.trading.q1': '[translate:최소 거래 단위는 얼마인가요?]',
'faq.trading.a1': '[translate:대부분의 귀금속 상품의 최소 거래 단위는 0.01랏입니다.]',
'faq.trading.q2': '[translate:레버리지는 어느 정도인가요?]',
'faq.trading.a2': '[translate:최대 1:100의 경쟁력 있는 레버리지를 제공합니다.]',
'faq.trading.q3': '[translate:거래 수수료가 있나요?]',
'faq.trading.a3': '[translate:당사는 스프레드 기반 모델을 사용하여 별도의 수수료를 부과하지 않습니다. 스프레드는 투명하고 공정하게 유지됩니다.]',
'faq.trading.q4': '[translate:자동 거래를 사용할 수 있나요?]',
'faq.trading.a4': '[translate:예, MT5 플랫폼은 EA(Expert Advisor)와 자동 거래 전략을 완벽히 지원합니다.]',

'faq.platform.q1': '[translate:어떤 거래 플랫폼을 지원하나요?]',
'faq.platform.a1': '[translate:당사는 주로 MetaTrader 5(MT5)를 사용합니다. MT5는 데스크톱(Windows/Mac), 모바일(iOS/Android), 웹에서 사용할 수 있습니다.]',
'faq.platform.q2': '[translate:MT5는 무료인가요?]',
'faq.platform.a2': '[translate:예, MT5는 무료로 다운로드 및 사용할 수 있습니다.]',
'faq.platform.q3': '[translate:모바일에서도 거래할 수 있나요?]',
'faq.platform.a3': '[translate:물론입니다. MT5 모바일 앱은 실시간 차트, 뉴스, 계좌 관리 기능을 모두 제공합니다.]',
'faq.platform.q4': '[translate:데모 계좌를 제공하나요?]',
'faq.platform.a4': '[translate:예, 가상 자금을 사용한 무료 데모 계좌를 제공합니다.]',

'faq.deposits.q1': '[translate:입금 방법은 어떤 것이 있나요?]',
'faq.deposits.a1': '[translate:은행 송금, 신용/직불카드(Visa, MasterCard), 다양한 전자 결제 방식을 지원합니다.]',
'faq.deposits.q2': '[translate:입금이 처리되는 데 얼마나 걸리나요?]',
'faq.deposits.a2': '[translate:카드 입금은 즉시 처리되며, 은행 송금은 1~3영업일, 전자 결제는 몇 시간 내에 완료됩니다.]',
'faq.deposits.q3': '[translate:입금 수수료가 있나요?]',
'faq.deposits.a3': '[translate:대부분의 입금 방법에 수수료를 부과하지 않습니다. 단, 은행이나 결제 서비스에서 별도 비용이 발생할 수 있습니다.]',
'faq.deposits.q4': '[translate:출금은 어떻게 하나요?]',
'faq.deposits.a4': '[translate:고객 포털에서 출금 요청을 제출할 수 있습니다. 출금은 원칙적으로 입금 시 사용한 동일한 방법으로 처리됩니다.]',

'faq.security.q1': '[translate:개인 정보는 어떻게 보호되나요?]',
'faq.security.a1': '[translate:SSL 256비트 암호화를 사용하여 데이터 전송을 보호합니다. 개인 정보는 안전하게 저장되며, 동의 없이 제3자에게 공유되지 않습니다.]',
'faq.security.q2': '[translate:2단계 인증(2FA)을 사용할 수 있나요?]',
'faq.security.a2': '[translate:예, 계정 보호를 위해 2FA 사용을 권장합니다.]',
'faq.security.q3': '[translate:비밀번호를 잊어버리면 어떻게 하나요?]',
'faq.security.a3': '[translate:로그인 페이지의 "비밀번호 찾기" 링크를 통해 재설정할 수 있으며, 이메일로 안전한 링크가 발송됩니다.]',
'faq.security.q4': '[translate:공정한 거래 환경은 어떻게 보장하나요?]',
'faq.security.a4': '[translate:실시간 시세, 중개 개입 없음, 엄격한 규제 준수를 통해 투명하고 공정한 거래 환경을 제공합니다.]',

'hero.browseFAQ': '[translate:FAQ 살펴보기]',
'hero.contactSupport': '[translate:지원팀에 문의하기]',

'contactCTA.phoneTitle': '[translate:전화 지원]',
'contactCTA.phoneDesc': '[translate:전문 상담원과 직접 통화]',
'contactCTA.callNow': '[translate:지금 전화하기]',
'contactCTA.emailTitle': '[translate:이메일 지원]',
'contactCTA.emailDesc': '[translate:상세한 답변을 이메일로 받기]',
'contactCTA.sendMsg': '[translate:메시지 보내기]',
'contactCTA.chatTitle': '[translate:라이브 채팅]',
'contactCTA.chatDesc': '[translate:즉시 메시지 상담]',
'contactCTA.available': '[translate:24시간 이용 가능]',
'contactCTA.startChat': '[translate:채팅 시작]',
'contactCTA.title': '[translate:아직 도움이 더 필요하신가요?]',
'contactCTA.subtitle': '[translate:전문 지원팀이 연중무휴로 도움을 드립니다.]',
'markets.specsTitle': '귀금속 및 외환 거래 규정',
'markets.specsDisclaimer': '* 거래 조건은 플랫폼 설정 및 시장 유동성에 따라 변경될 수 있습니다.',
'markets.spreadTypeFloating': '변동 스프레드',
'markets.points': '포인트',
'markets.variableByMarket': '시장 상황에 따라 변동',

'markets.table.symbol': '종목',
'markets.table.contractUnit': '계약 단위',
'markets.table.minLot': '최소 거래량',
'markets.table.maxLot': '최대 거래량',
'markets.table.leverage': '레버리지',
'markets.table.spreadType': '스프레드 유형',
'markets.table.avgSpread': '평균 스프레드',
'markets.table.swapLong': '스왑 롱',
'markets.table.swapShort': '스왑 숏',
'markets.contractSections.contractSize.title': '계약 크기',
'markets.contractSections.contractSize.items.xauusd.label': '금 (XAUUSD)',
'markets.contractSections.contractSize.items.xauusd.desc': '금 거래의 표준 계약 크기',
'markets.contractSections.contractSize.items.xagusd.label': '은 (XAGUSD)',
'markets.contractSections.contractSize.items.xagusd.desc': '은 거래의 표준 계약 크기',
'markets.contractSections.contractSize.items.gaucnh.label': 'GAUCNH',
'markets.contractSections.contractSize.items.gaucnh.desc': '역외 위안화 관련 FX 거래의 표준 계약 크기',

'markets.contractSections.priceMove.title': '최소 가격 변동',
'markets.contractSections.priceMove.items.goldTick.label': '금 틱 사이즈',
'markets.contractSections.priceMove.items.goldTick.desc': '최소 가격 변동 단위',
'markets.contractSections.priceMove.items.silverTick.label': '은 틱 사이즈',
'markets.contractSections.priceMove.items.silverTick.desc': '최소 가격 변동 단위',
'markets.contractSections.priceMove.items.fxTick.label': '외환 틱 사이즈',
'markets.contractSections.priceMove.items.fxTick.desc': '통화쌍 가격의 최소 변동 단위',

'markets.contractSections.settlement.title': '결제 방식',
'markets.contractSections.settlement.items.type.label': '결제 유형',
'markets.contractSections.settlement.items.type.value': '현금 결제',
'markets.contractSections.settlement.items.type.desc': '실물 인도는 필요하지 않습니다',
'markets.contractSections.settlement.items.currency.label': '결제 통화',
'markets.contractSections.settlement.items.currency.desc': '귀금속 상품은 미국 달러로 결제됩니다',
'markets.contractSections.settlement.items.fxQuote.label': '호가 통화',
'markets.contractSections.settlement.items.fxQuote.desc': 'GAUCNH 는 CNH 기준으로 호가됩니다',

'markets.contractSections.positionLimits.title': '포지션 제한',
'markets.contractSections.positionLimits.items.maxPosition.label': '최대 포지션',
'markets.contractSections.positionLimits.items.maxPosition.desc': '계좌별 종목당 제한',
'markets.contractSections.positionLimits.items.orderDistance.label': '주문 거리',
'markets.contractSections.positionLimits.items.orderDistance.desc': '시장 가격으로부터의 최소 거리',
'markets.contractSections.positionLimits.items.execution.label': '체결 방식',
'markets.contractSections.positionLimits.items.execution.value': '시장가 체결',
'markets.contractSections.positionLimits.items.execution.desc': '주문은 시장 유동성 조건에 따라 체결됩니다',

'markets.days.monday': '월요일',
'markets.days.tuesday': '화요일',
'markets.days.wednesday': '수요일',
'markets.days.thursday': '목요일',
'markets.days.friday': '금요일',
'markets.days.saturday': '토요일',
'markets.days.sunday': '일요일',

'markets.hours.monThu': '06:00 - 04:59',
'markets.hours.friday': '06:00 - 04:57',
'markets.hours.closed': '휴장',

'markets.holidays.newYear.date': '1월 1일',
'markets.holidays.newYear.event': '신정',
'markets.holidays.christmas.date': '12월 25일',
'markets.holidays.christmas.event': '크리스마스',
'markets.holidays.independence.date': '7월 4일',
'markets.holidays.independence.event': '미국 독립기념일',
'markets.holidays.thanksgiving.date': '11월 24일',
'markets.holidays.thanksgiving.event': '추수감사절',
"hero.cta.accountOpening": "계좌 개설 안내",
"hero.cta.depositWithdraw": "입출금 안내"
,
  "androidDownload.title": "MetaTrader 5 다운로드",
  "androidDownload.description": "잠시 후 Google Play로 자동 이동합니다. 기기에서 Google Play를 사용할 수 없는 경우 APK를 직접 다운로드할 수 있습니다.",
  "androidDownload.autoRedirect": "{{seconds}}초 후 Google Play로 이동합니다",
  "androidDownload.openGooglePlay": "Google Play 열기",
  "androidDownload.downloadApk": "APK 직접 다운로드",
  "androidDownload.hint": "Google Play가 열리지 않으면 “APK 직접 다운로드”를 눌러 주세요.",
  'windowsDownload.pageTitle': 'Windows MT5 다운로드',
  'windowsDownload.pageDesc': '사용자에게 적합한 설치 버전을 선택하세요.',
  'windowsDownload.badge': 'Windows MT5 다운로드',
  'windowsDownload.title': '설치 패키지를 선택하세요',
  'windowsDownload.description': 'Windows MT5 설치 패키지를 선택하세요. Gold Label Smooth Stable Version은 중국 본토 및 홍콩 사용자에게 권장됩니다. 기존 공식 설치 파일도 선택할 수 있습니다.',
  'windowsDownload.smoothTitle': '1. Gold Label Smooth Stable Version',
  'windowsDownload.smoothDesc': '중국 본토 / 홍콩 Windows 사용자에게 권장됩니다. 공식 설치 파일 사용이 불편한 다른 지역 사용자도 사용할 수 있습니다.',
  'windowsDownload.smoothButton': 'Gold Label Smooth Stable Version 다운로드',
  'windowsDownload.officialTitle': '2. MetaQuotes 공식 설치 파일',
  'windowsDownload.officialDesc': '기존 다운로드 링크입니다. 중국 본토 Windows 사용자는 가끔 설치 문제가 발생할 수 있으며, 다른 지역 고객에게는 영향이 없습니다.',
  'windowsDownload.officialButton': '공식 설치 파일 다운로드',

  // Economic calendar explorer
  'calendar.hongKongTime': '홍콩 시간 (GMT+8)',
  'calendar.previousDays': '이전 7일',
  'calendar.nextDays': '다음 7일',
  'calendar.today': '오늘',
  'calendar.jumpToDate': '날짜로 이동',
  'calendar.completeView': '전체 보기',
  'calendar.allDays': '7일 전체',
  'calendar.events': '개 이벤트',
  'calendar.impactAll': '전체 중요도',
  'calendar.impactHigh': '높음',
  'calendar.impactMedium': '중간',
  'calendar.impactLow': '낮음',
  'calendar.searchPlaceholder': '이벤트, 국가 또는 통화 검색',
  'calendar.eventsFound': '개 이벤트 표시',
  'calendar.lastUpdated': '마지막 업데이트',
  'calendar.loadError': '경제 캘린더를 일시적으로 불러올 수 없습니다.',
  'calendar.noEvents': '현재 보기와 일치하는 경제 이벤트가 없습니다.',
  'calendar.tryAnotherDate': '다른 날짜를 선택하거나 필터를 해제하세요.',
  'calendar.time': '시간',
  'calendar.impact': '중요도',
  'calendar.released': '발표됨',
  'calendar.pending': '발표 예정',
  'calendar.disclaimer': '일정 시간은 홍콩 시간 기준입니다. 수치는 수정될 수 있으며 정보 제공 목적으로만 제공됩니다.',
  'news.tab.newsDesc': '최신 시장 뉴스, 금 분석 및 교육 콘텐츠',
  'news.tab.calendarDesc': '앞뒤 날짜의 주요 경제 이벤트와 발표 수치 확인',
  'news.autoRefresh': '뉴스 정보는 자동으로 새로고침됩니다',

  'news.tabs.news': '뉴스',
  'news.tabs.calendar': '경제 캘린더',

};

export default common;
